@if (!showSkeletonLoader) {
  @if (config.data && config.data.bannerUrl != undefined) {
    <div class="bannercontainer">
      @if (config.data.link) {
        <!-- <a title="{{config.data.widget_name}}" href="{{config.data.link}}" *ngIf="config.data.isExternalLink" target="_blank" > -->
        <!-- <img [attr.src]="config.data.bannerUrl" /> -->
      <!-- </a> -->
      <!-- <a style="cursor: pointer;" (click)="goto(config.data.link)" class="{{config.data.link}}" title="{{config.data.widget_name}}"  *ngIf="!config.data.isExternalLink" > -->
    <!-- </a> -->
    <!-- <div class="banner-image-container"> top bottom middle -->
    <img [attr.src]="config.data.bannerUrl" />
    @if (this.config!=undefined && this.config.data!=undefined && this.config.data.ctaPosition!=undefined &&  this.config.data.ctaPosition) {
      <div class="banner-cta"
        [ngClass]="{top: this.config.data.ctaPosition == 'RightTop', bottom: this.config.data.ctaPosition == 'RightBottom', middle: this.config.data.ctaPosition == 'RightMiddle'}">
        @if (!config.data.isExternalLink) {
          <a style="cursor: pointer;" (click)="goto(config.data.link)" class="{{config.data.link}}"
            title="{{config.data.widget_name}}">
            <i class="fa fa-chevron-right" aria-hidden="true"></i>
          </a>
        }
        @if (config.data.isExternalLink) {
          <a style="cursor: pointer;" title="{{config.data.widget_name}}" href="{{config.data.link}}" target="_blank" ></a>
        }
      </div>
    }
  }
  @if (!config.data.link) {
    <img title="{{config.data.widget_name}}" [attr.src]="config.data.bannerUrl" />
  }
</div>
}
}
@if (showSkeletonLoader) {
  <div class="extra_width">
    <app-skeleton-loader [height]="height"></app-skeleton-loader>
  </div>
}
